import { useQuery } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const get = async (paging?: TPaging) => {
  const response: TServerResponse = await request({
    url: apiUrls.blogs.FETCH_BLOGS,
    method: "GET",
    params: { ...paging },
  });
  return response;
};

export const useBlogsQuery = (paging: TPaging) => {
  return useQuery({
    queryKey: [apiUrls.blogs.FETCH_BLOGS, paging],
    queryFn: () => get(paging),
  });
};
